import $ from 'jquery';

export default function Stuff(vm) {
    this.all = function(params) {
        var url = '/stuff-available/list?' + $.param(params);

        return vm.get(url);
    };
}